<template>
  <div class="basic-block block-biorhythm" :style="styles">
    <div class="inner-panel">
      <h3><img src="/static/img/recommend/lp/kurenotori/products/head_biorhythm.png" alt=""> </h3>
      <biorhythm-panel
        :def-target-num="targetNum"
        :terms-num="termsNum"
        :block-height-ratio="0.8928"
        :result-data="resultData"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :lp-id="lpId"
      />
      <div class="day-detail-wrap">
        <biorhythm-detail-item
          v-for="n of detailOpenedNum"
          :key="`pre${n}`"
          :day-info="resultData[n]"
        />
        <div class="hidden-items-wrap">
          <biorhythm-detail-item
            :day-info="resultData[detailOpenedNum + 1]"
            :is-panel-ctrl="true"
            :panel-open="isPanelOpen"
            @panel-ctrl-click="onPanelCtrlClick"
          />
          <transition name="hidden">
            <div class="hidden-items" :class="{open: isPanelOpen}" v-show="isPanelOpen">
              <biorhythm-detail-item
                v-for="n of (termsNum + 1 - detailOpenedNum)"
                :key="`hidden${n}`"
                :day-info="resultData[n + detailOpenedNum]"
                :no-head="n === 1"
              />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiorhythmPanel from './BiorhythmPanel'
import BiorhythmDetailItem from './BiorhythmDetailItem'
import {BIORHYTHM_SCORE_MASTER} from '../constants'

export default {
  name: 'BlockBiorhythm',
  components: {BiorhythmDetailItem, BiorhythmPanel},
  data(){
    return {
      isPanelOpen: false,
      detailOpenedNum: 3,
      termsNum: 6, // 対象期間（今日を除く）
      targetNum: 10, // 全体の有効日数（見切れ分２つは除く）
    }
  },
  props: {
    targetInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    lpId: {
      type: Number,
      default: 1,
    },
    resultData: {
      type: Array,
      required: true,
    }
  },
  computed: {
    resultScoreList(){
      const rtn = []
      for( let i = 0; i < this.targetNum + 2; i++ ){
        rtn.push(BIORHYTHM_SCORE_MASTER[parseInt(Math.random() * BIORHYTHM_SCORE_MASTER.length)])
      }
      return rtn
    },
    colorScheme() {
      return {
        lineColor: '#537fe4',
        currentBg: '#fff8c2',
        termsBg: '#e3f7f9',
        outOfTermBg: '#f7f7f7',
        // baseBg: '#9f93d0',
        baseBg: 'white',
        ruledLine: 'white',
      }
    },
    styles() {
      return {
        '--key-color': this.targetInfo.colorScheme.keyColor
      }
    }
  },
  methods: {
    onPanelCtrlClick(){
      this.isPanelOpen = !this.isPanelOpen
    }
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

.block-biorhythm {
  padding: 20px;
  .inner-panel {
    background: white;
    padding: 30px 20px 24px;
    border: 1px solid var(--key-color);
    border-radius: 10px;
    h3 {
      margin: 0;
      padding: 4px 0 24px;
      img {
        width: 100%;
      }
    }
  }
}

.hidden {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out 0s;
  }
  &-enter, &-leave-to {
    opacity: 0;
    transform: translate(0, -10px);
  }
  &-enter-to, &-leave {
    transform: translate(0, 0);
    opacity: 1;
  }
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/partials/BlockBiorhythm.vue